export enum NavigationKeys {
  Tab = 'Tab',
  Enter = 'Enter',
  Escape = 'Escape',
  ' ' = ' ', // Space key
  Home = 'Home',
  End = 'End',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown'
}

export enum AlphabeticKeys {
  a = 'a',
  b = 'b',
  c = 'c',
  d = 'd',
  e = 'e',
  f = 'f',
  g = 'g',
  h = 'h',
  i = 'i',
  j = 'j',
  k = 'k',
  l = 'l',
  m = 'm',
  n = 'n',
  o = 'o',
  p = 'p',
  q = 'q',
  r = 'r',
  s = 's',
  t = 't',
  u = 'u',
  v = 'v',
  w = 'w',
  x = 'x',
  y = 'y',
  z = 'z'
}

export const NUMERIC_KEYS = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9'
};

export enum EventActions {
  Focus = 'focus',
  Select = 'select'
}
